import axios from 'axios';
import config from '@/config/env-constants';

export default {

    importAssets(param) {
        let url = `${config.cloudFunctionsBaseUrl}/importAssets`;
        return axios.post(url, param);
    },

    importDispatch(param) {
        let url = `${config.cloudFunctionsBaseUrl}/importDispatch`;
        return axios.post(url, param);
    },

    importCompanies(param) {
        let url = `${config.cloudFunctionsBaseUrl}/importCompanies`;
        return axios.post(url, param);
    },

    importStorageLocations(param) {
        let url = `${config.cloudFunctionsBaseUrl}/importStorageLocations`;
        return axios.post(url, param);
    },

    importTransportations(param) {
        let url = `${config.cloudFunctionsBaseUrl}/importTransportations`;
        return axios.post(url, param);
    },

    importUsers(param) {
        let url = `${config.cloudFunctionsBaseUrl}/importUsers`;
        return axios.post(url, param);
    }
}
